module.exports = __webpack_public_path__ + "img/inprogress-payment.1fef4af0.png";